import PropTypes from 'prop-types';

import { ConfirmModal } from '#globalComponents/Overlay/ConfirmModal';

/**
 * Last stop before a paid add-on activation charges the subscription. `onConfirm` must reject on
 * failure so the dialog stays open (see ConfirmModal).
 */
const AddonPurchaseConfirmModal = ({ addon, isOpen, onClose, onConfirm, isLoading }) => (
	<ConfirmModal
		isOpen={isOpen}
		onClose={onClose}
		onConfirm={onConfirm}
		title={`${addon.name}-Add-on buchen`}
		message={`Möchten Sie das ${addon.name}-Add-on für ${addon.priceLabel} kostenpflichtig buchen?`}
		subtitle="Das Add-on wird sofort freigeschaltet und mit Ihrem Abonnement abgerechnet. Monatlich kündbar."
		confirmText="Kostenpflichtig buchen"
		confirmVariant="solid"
		icon={addon.icon}
		isLoading={isLoading}
	/>
);

AddonPurchaseConfirmModal.propTypes = {
	addon: PropTypes.shape({
		name: PropTypes.string.isRequired,
		priceLabel: PropTypes.string.isRequired,
		icon: PropTypes.elementType.isRequired,
	}).isRequired,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
};

export default AddonPurchaseConfirmModal;
